import { ReactNode, useMemo, useRef, useState } from 'react';

export type AgreementCheckboxType = {
	tooltipTitle?: string;
	fieldName: string;
	label: ReactNode;
	required?: boolean;
};

export type AgreementCheckboxStateType = AgreementCheckboxType & {
	checked: boolean;
};

export const useAgreementCheckboxWrapper = (checkboxes: AgreementCheckboxType[]) => {
	const checkboxesRef = useRef(null);

	const [checkedCheckboxes, setCheckedCheckboxes] = useState<AgreementCheckboxStateType[]>(
		checkboxes.map(item => ({ ...item, checked: false }))
	);

	const isValid = useMemo(() => checkedCheckboxes.every(item => item.checked), [checkedCheckboxes]);

	const onChange = (fieldName: string) => {
		setCheckedCheckboxes(prev =>
			prev.map(item => (item.fieldName === fieldName ? { ...item, checked: !item.checked } : item))
		);
	};

	const scrollToCheckboxes = () => {
		checkboxesRef.current.scrollIntoView({ behavior: 'smooth' });
	};

	return {
		// data
		checkboxesRef,
		isValid,

		// checkboxes
		checkedCheckboxes,

		// methods
		onChange,
		scrollToCheckboxes
	};
};
